import {useState} from 'react'
import {Marker, useGoogleMap} from '@react-google-maps/api'
import CustomInfoWindow from './CustomInfoWindow'

const markerIcon = type => {
    const color = type === 'dealer' ? '#8AB73F' : '#3F8CB7'

    return {
        path: 'M10.9 2a8.9 8.9 0 0 0-7.093 14.28l6.706 8.972h.773l6.706-8.972A8.9 8.9 0 0 0 10.9 2Zm0 11.853a2.952 2.952 0 1 1 2.953-2.953 2.955 2.955 0 0 1-2.953 2.953Z',
        fillColor: color,
        fillOpacity: 1,
        scale: 1.5,
        strokeColor: color,
        strokeWeight: 8,
        strokeOpacity: 0.13,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(10, 27)
    }
}

const CustomMarker = ({dealer, type}) => {
    const { latitude, longitude } = dealer

    if (latitude === null || longitude === null) return null

    const map = useGoogleMap()
    const [infoOpen, setInfoOpen] = useState(false)
    const [markerObject, setMarkerObject] = useState(new google.maps.MVCObject)

    const handleOnClick = event => {
        setInfoOpen(!infoOpen)
        map.panTo(event.latLng)
    }

    return (
        <>
            <Marker
                position={{lat: latitude, lng: longitude}}
                clickable={true}
                onClick={event => handleOnClick(event)}
                onLoad={marker => setMarkerObject(marker)}
                icon={markerIcon(type)}
            />
            {infoOpen && (
                <CustomInfoWindow
                    anchor={markerObject}
                    dealer={dealer}
                    onCloseClick={() => setInfoOpen(false)}
                />
            )}
        </>
    )
}

export default CustomMarker